import { AxiosError } from "axios";


const ErrorIcon = ({
  size,
  color,
}: {
  size?: number | string;
  color?: string;
}) => (
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8838 0.532004C10.5378 -0.121996 9.46178 -0.121996 9.11578 0.532004L0.115783 17.532C0.0350719 17.6844 -0.00485176 17.8551 -0.000110181 18.0275C0.0046314 18.1999 0.053877 18.3681 0.142844 18.5159C0.23181 18.6636 0.357474 18.7858 0.507628 18.8707C0.657782 18.9555 0.827323 19.0001 0.999783 19H18.9998C19.1722 19.0004 19.3418 18.956 19.4921 18.8713C19.6423 18.7866 19.768 18.6644 19.8569 18.5167C19.9458 18.3689 19.995 18.2006 19.9995 18.0282C20.004 17.8559 19.9638 17.6852 19.8828 17.533L10.8838 0.532004ZM10.9998 16H8.99978V14H10.9998V16ZM8.99978 12V7H10.9998L11.0008 12H8.99978Z"
      fill={color}
    />
  </svg>
);

export default function ErrorScreen({
  title = "Inpossible de charger",
  description,
  height,
  statusCode,
  color = " #6767678d",
  axiosError,
}: {
  title?: string;
  description?: string;
  goHome?: boolean;
  height?: string;
  color?: string;
  statusCode?: number;
  axiosError?: AxiosError;

  noAxiosMessageToDisplay?: boolean;
}) {
  const statusCodeFormated = statusCode || axiosError?.response?.status;
  const axiosMessageData = axiosError?.response?.data as any;
  const descriptionFormated =
    description ||
    axiosMessageData?.message ||
    axiosMessageData?.error ||
    description;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        height: height || "100%",
        width: "100%",
        color: color,
      }}
    >
      <ErrorIcon size={30} color={color} />
      <h2 style={{ fontSize: "0.9rem", textAlign: "center" }}>
        {title} {statusCodeFormated ? `(${statusCodeFormated})` : ""}
      </h2>
      <p style={{ fontSize: "0.7rem", textAlign: "center" }}>
        {descriptionFormated}
      </p>
    </div>
  );
}
